export const generateSlug = (title) => {
  return title
    .toLowerCase() // Convert to lowercase
    .trim() // Remove leading/trailing spaces
    .normalize("NFD") // Normalize accents like é to e
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, "") // Remove invalid characters (keep a-z, 0-9, space, hyphen)
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single
    .replace(/^-+|-+$/g, ""); // Trim hyphens from start/end
};

export const generateSlug2 = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "") // Remove invalid chars
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/-+/g, "-"); // Collapse multiple -
};

export function parseSlug(slug) {
  const lastHyphenIndex = slug.lastIndexOf("-");

  if (lastHyphenIndex === -1) {
    return { baseSlug: slug, timestamp: "" };
  }

  const possibleTimestamp = slug.substring(lastHyphenIndex + 1);

  if (/^\d{13}$/.test(possibleTimestamp)) {
    return {
      baseSlug: slug.substring(0, lastHyphenIndex),
      timestamp: possibleTimestamp,
    };
  }

  // Not a timestamp → return original slug
  return {
    baseSlug: slug,
    timestamp: "",
  };
}
